import { t } from "ember-intl";
import Dropdown from "glesys-controlpanel/components/dropdown";
import IconsMoreHorizontal from "glesys-controlpanel/components/icons/more-horizontal";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

export const MenuAnchor = <template>
  <span class="w-9 h-8 [anchor-name:--entity-actions]"></span>
</template>;

<template>
  <div
    class="absolute top-3 right-[3.75rem] sm:top-4 sm:right-[4.25rem] [position-anchor:--entity-actions] [@supports(anchor-name:--entity-actions)]:right-auto [@supports(anchor-name:--entity-actions)]:left-[anchor(left)] [@supports(anchor-name:--entity-actions)]:top-[anchor(top)]"
    {{mergeClasses}}
    ...attributes
  >
    <Dropdown
      class="w-9 h-8 flex items-center justify-center rounded-sm bg-white border border-gray-200 text-gray-600 cursor-pointer hover:border-gray-300 hover:bg-gray-50 hover:text-gray-800"
      aria-label={{t "label.action-menu-aria-label" name=@title}}
      data-test-entity-menu
      @chevron={{false}}
    >
      <:header>
        <IconsMoreHorizontal class="w-12" />
      </:header>
      <:default>
        {{yield}}
      </:default>
    </Dropdown>
  </div>
</template>
